module.exports = __webpack_public_path__ + "static/media/pannon.8853c3b3.png";